import * as React from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import TermItemSelectWithSearch from '../../../Term/Components/TermItemSelectWithSearch';
import { TermType } from '../../../Term/Enums/TermType.enum';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue | string;
	error?: FieldError;
}

const WorkplaceFieldOFCare: React.FC<Props> = props => (
	<TermItemSelectWithSearch
		{...props}
		termType={TermType.TYPE_FORM_OF_CARE_SUKL}
	/>
);

export default WorkplaceFieldOFCare;
